import React from 'react';

import { PriceTypeDetail } from 'components/blocks/PriceType';

const DetailScreen = (props) => {
  return (
    <div className="page-main">
      <PriceTypeDetail />
    </div>
  );
};

export default DetailScreen;
